import { NavLink, useLocation } from 'react-router-dom';
import "./Menu.css";
import Logo from '../../components/logo/LogoMenu';


export default function Menu({ onClick, isClicked, isMode }) {

    const location = useLocation();
    // Funzione per determinare se un NavLink è attivo
    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <aside className={`${isClicked ? "" : "show-menu-sx"} layout-menu-fixed layout-menu menu-vertical menu bg-menu-theme`} >
            {/* Logo */}
            <Logo onClick={onClick} isClicked={isClicked} isMode={isMode} />
             <ul className="menu-inner py-1 ps ps--active-y">
                <li className={isActive("/home") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/home" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-home-smile"></i>
                        <div className="text-truncate">Home</div>
                    </NavLink>
                </li>
                <li className={isActive("/client") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/client" className="menu-link">
                        <i className="menu-icon tf-icons bx bxs-contact"></i>
                        <div className="text-truncate">Clienti</div>
                    </NavLink>
                </li>
                <li className={isActive("/event") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/event" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-calendar-event"></i>
                        <div className="text-truncate">Eventi</div>
                    </NavLink>
                </li>
                <li className={isActive("/contract") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/contract" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-file"></i>
                        <div className="text-truncate">Contratti</div>
                    </NavLink>
                </li>
                <li className={isActive("/materials") || isActive("/categories") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/materials" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-store-alt"></i>
                        <div className="text-truncate">Materiali</div>
                    </NavLink>
                </li>
                <li className={isActive("/schedule-pay") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/schedule-pay" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-calendar-week"></i>
                        <div className="text-truncate">Pagamenti</div>
                    </NavLink>
                </li>
                <li className={isActive("/timeline") || isActive("/activity-groups") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/timeline" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-timer"></i>
                        <div className="text-truncate">Timeline</div>
                    </NavLink>
                </li>
             </ul>
        </aside>
  );
}